module.exports = __webpack_public_path__ + "img/cqrmyylogo2.785d32b8.png";